import * as React from 'react'
import {
  ImageList,
  ImageListItem,
  ImageListItemBar,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
  Skeleton,
} from '@mui/material'
import WebsiteJson from '../../Assets/JSON/MV.json'
import InfoIcon from '@mui/icons-material/Info'

const Infrastructure = () => {
  const infrastructure_data = WebsiteJson.Infra_Structure
  const [openDialog, setOpenDialog] = React.useState(false)
  const [selectedItem, setSelectedItem] = React.useState(null)
  const [loading, setLoading] = React.useState(true)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'))

  const handleOpenDialog = (item) => {
    setSelectedItem(item)
    setOpenDialog(true)
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  const getCols = () => {
    if (isMobile) return 1
    if (isTablet) return 2
    return 3
  }

  const getRowHeight = () => {
    if (isMobile) return 200
    if (isTablet) return 240
    return 300
  }

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false)
    }, 1500)

    return () => clearTimeout(timer)
  }, [])

  return (
    <Box
      sx={{
        py: 8,
        px: { xs: 2, sm: 4, md: 6 },
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Typography
        variant="h3"
        component="h2"
        align="center"
        gutterBottom
        sx={{
          fontWeight: 'bold',
          mb: 6,
          color: theme.palette.text.primary,
          textShadow: '1px 1px 2px rgba(0,0,0,0.1)',
        }}
      >
        Infrastructure of our College
      </Typography>

      {loading ? (
        <ImageList cols={getCols()} gap={16}>
          {Array.from(new Array(6)).map((_, index) => (
            <ImageListItem key={index}>
              <Skeleton
                variant="rectangular"
                width="100%"
                height={getRowHeight()}
                sx={{ borderRadius: 2 }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      ) : (
        <ImageList
          variant="masonry"
          cols={getCols()}
          gap={16}
          sx={{
            width: '100%',
            height: 'auto',
            overflow: 'hidden',
            borderRadius: 2,
            boxShadow: 3,
          }}
        >
          {infrastructure_data &&
            infrastructure_data.map((item, index) => (
              <ImageListItem
                key={index}
                onClick={() => handleOpenDialog(item)}
                sx={{
                  cursor: 'pointer',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.02)',
                    boxShadow: theme.shadows[6],
                    '& .MuiImageListItemBar-root': {
                      opacity: 1,
                    },
                  },
                }}
              >
                <img
                  src={item.ImageURL}
                  alt={item.Title}
                  loading="lazy"
                  style={{
                    width: '100%',
                    height: getRowHeight(),
                    objectFit: 'cover',
                    borderRadius: theme.shape.borderRadius,
                  }}
                  onError={(e) => {
                    e.target.src =
                      'https://dbraeiassetmanagement.blob.core.windows.net/dbraimt/prod/home/Placeholders/Placeholder_Image.jpg'
                  }}
                />
                <ImageListItemBar
                  title={item.Title}
                  subtitle={item.Description}
                  sx={{
                    borderBottomLeftRadius: theme.shape.borderRadius,
                    borderBottomRightRadius: theme.shape.borderRadius,
                    background:
                      'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
                    opacity: 0.9,
                    transition: 'opacity 0.3s ease',
                  }}
                  actionIcon={
                    <IconButton
                      sx={{ color: 'rgba(255, 255, 255, 0.9)' }}
                      aria-label={`info about ${item.Title}`}
                    >
                      <InfoIcon />
                    </IconButton>
                  }
                />
              </ImageListItem>
            ))}
        </ImageList>
      )}

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            overflow: 'hidden',
            maxHeight: '90vh',
          },
        }}
      >
        {selectedItem && (
          <>
            <DialogTitle
              sx={{
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                fontWeight: 'bold',
                py: 2,
                px: 3,
              }}
            >
              {selectedItem.Title}
            </DialogTitle>
            <DialogContent sx={{ p: 0 }}>
              <Box
                sx={{
                  width: '100%',
                  height: '60vh',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: theme.palette.grey[100],
                }}
              >
                <img
                  src={selectedItem.ImageURL}
                  alt={selectedItem.Title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    padding: theme.spacing(2),
                  }}
                  onError={(e) => {
                    e.target.src =
                      'https://dbraeiassetmanagement.blob.core.windows.net/dbraimt/prod/home/Placeholders/Placeholder_Image.jpg'
                  }}
                />
              </Box>
              {selectedItem.Description && (
                <Box sx={{ p: 3 }}>
                  <Typography variant="body1" paragraph>
                    {selectedItem.Description}
                  </Typography>
                </Box>
              )}
            </DialogContent>
            <DialogActions
              sx={{
                backgroundColor: theme.palette.grey[100],
                px: 3,
                py: 2,
                borderTop: `1px solid ${theme.palette.divider}`,
              }}
            >
              <Button
                onClick={handleCloseDialog}
                variant="contained"
                color="primary"
                sx={{
                  borderRadius: 2,
                  px: 4,
                  py: 1,
                  textTransform: 'none',
                  fontWeight: 'bold',
                }}
              >
                Close
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </Box>
  )
}

export default Infrastructure
